module.exports = __webpack_public_path__ + "img/innovationscreen.3f12192e.png";